import { useEffect } from 'react'

/**
 * useScriptLoader
 * author: soojin.oh
 */

/**
 * React 에서 script tag 의 onLoad 가 동작되지 않음. (이유는 모르겠음)
 * 따라서 동적으로 script 를 로드하고자 할때 아래의 hook 을 사용하도록 한다.
 *
 * @param scriptUrl 로드 할 스크립트의 url
 * @param onLoad callback
 * @param id 중복 로드 방지를 위해 id 설정. 한화면에 두번이상 로드해야 할 경우가 있다면 사용하도록 한다
 */
const useScriptLoader = (scriptUrl: string, onLoad: () => void, id?: string) => {
  useEffect(() => {
    if (id) {
      const existingScript = document.getElementById(id)
      if (existingScript) {
        // 이미 로드된 스크립트가 존재함.
        return
      }
    }

    const script = document.createElement('script')
    script.src = scriptUrl
    if (id) {
      script.id = id
    }
    document.body.appendChild(script)
    script.onload = onLoad
    return () => void document.body.removeChild(script)
  }, [onLoad])
}

export default useScriptLoader
